import React from 'react';
import Styles from '../ClubSpecs.module.scss';

const DriverFairwayHybridSpec = (props) => {
  const { clubItem, getFormattedDate } = props;

  return (
    <>
      {clubItem?.enter_date && (
        <div className={Styles.specItem}>
          BUILD DATE:
          <span className={Styles.specValue}>
            {getFormattedDate(new Date(clubItem.enter_date))}
          </span>
        </div>
      )}
      {clubItem?.color_code && (
        <div className={Styles.specItem}>
          LOFT:
          <span className={Styles.specValue}>{clubItem.color_code}</span>
        </div>
      )}
      {/* {clubItem?.color_code && (
        <div className={Styles.specItem}>HOSEL CODE:
          <span className={Styles.specValue}>{clubItem.color_code}</span>
        </div>)} not currently returned in data */}
      {clubItem?.swing_weight && (
        <div className={Styles.specItem}>
          SWING WEIGHT:
          <span className={Styles.specValue}>{clubItem.swing_weight}</span>
        </div>
      )}
      {clubItem?.shaft && (
        <div className={Styles.specItem}>
          SHAFT:
          <span className={Styles.specValue}>{clubItem.shaft}</span>
        </div>
      )}
      {clubItem?.length && (
        <div className={Styles.specItem}>
          LENGTH:
          <span className={Styles.specValue}>{clubItem.length}</span>
        </div>
      )}
      {clubItem?.grip && (
        <div className={Styles.specItem}>
          GRIP:
          <span className={Styles.specValue}>{clubItem.grip}</span>
        </div>
      )}
      {clubItem?.grip_over_size && (
        <div className={Styles.specItem}>
          GRIP SIZE:
          <span className={Styles.specValue}>{clubItem.grip_over_size}</span>
        </div>
      )}
    </>
  );
};

export default DriverFairwayHybridSpec;
